import { TableView } from "../view";

// <reference path="../view.ts" />

export class SoilViews extends TableView {

    constructor() {

        super(false, false, false, [new SoilView(), new SoilFieldAllocView()])

        this._key = this._template = "groupsoil"
        this._name = "Soil analysis"

    }
}

export class SoilView extends TableView {

    constructor() {

        super(false, false, false);
        this._key = this._template = "soil"
        this._name = "List"
    }

}

export class SoilFieldAllocView extends TableView {

    constructor() {
        super(false, true, false);
        this._key = this._template = this._template = "soil-field-alloc";
        this._name = "Allocations";
    }

}

